import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function fieldsMatchValidator(
  field: string = 'password',
  confirmField: string = 'confirmPassword',
  fieldMsgName: string = 'Password',
  confirmFieldMsgName: string = 'Confirm Password'
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const fieldControl = control.get(field);
    const confirmFieldControl = control.get(confirmField);

    if (!fieldControl || !confirmFieldControl) {
      return null;
    }

    const fieldValue = fieldControl.value;
    const confirmFieldValue = confirmFieldControl.value;

    if (!fieldValue || !confirmFieldValue) {
      return null;
    }

    if (fieldValue !== confirmFieldValue) {
      const error = { fieldMismatch: `${fieldMsgName} and ${confirmFieldMsgName} must match` }
      confirmFieldControl.setErrors(error);
      return error;
    }

    if (confirmFieldControl.hasError('fieldMismatch')) {
      const errors = { ...confirmFieldControl.errors };
      delete errors['fieldMismatch'];
      confirmFieldControl.setErrors(
        Object.keys(errors).length ? errors : null
      );
    }

    return null;
  };
}
